import { z } from 'zod'
import { required } from '../shared/required'

/*
 * Regra de senha do cliente, fonte única (a mesma da API desde os débitos 41 e 42): cadastro e recuperação (auth),
 * troca logada e conclusão de cadastro (customer) e o quadro PasswordRequirements importam daqui. Arquivo próprio para
 * o customer importar a regra sem depender dos formulários do auth (que importam os campos do cliente do customer).
 */

export const PASSWORD_RULES = { min: 8, max: 45, specials: '$%&@' } as const
const passwordSpecial = new RegExp(`[${PASSWORD_RULES.specials.replace(/[\\\]^-]/g, '\\$&')}]`)

export const PasswordSchema = z
    .string(required('Informe sua nova senha'))
    .min(PASSWORD_RULES.min, `Deve conter no minímo ${PASSWORD_RULES.min} caracteres`)
    .max(PASSWORD_RULES.max, `Deve conter no máximo ${PASSWORD_RULES.max} caracteres`)
    .refine((value) => /[A-Z]/.test(value), {
        message: 'Deve conter pelo menos uma letra maiúscula',
    })
    .refine((value) => passwordSpecial.test(value), {
        message: `Deve conter pelo menos um caractere especial (${PASSWORD_RULES.specials})`,
    })

/** Confirmação igual à senha, no campo `confirmPassword` (cadastro e conclusão de cadastro). */
export const PASSWORDS_MATCH = {
    message: 'As senhas não são iguais',
    path: ['confirmPassword'],
}

/** Confirmação da senha no cadastro e na conclusão de cadastro (a igualdade é conferida pelo `PASSWORDS_MATCH`). */
export const ConfirmPasswordSchema = z.string(required('Deve informar uma senha'))
